/* eslint-disable react/prop-types */
import React, { createContext, useState, useEffect } from 'react'
import { LG_SIZE, SM_SIZE } from '../utils/constants'

const initialState = {
  userObj: {},
  isLogin: false,
  activePlans: [],
  userId: '',
}
//create context

export const AppContext = createContext(initialState)

//Provider Component

export const AppProvider = ({ children }) => {
  const [loader, setLoader] = useState(false)
  const [uploadFinishCallback, setUploadFinishCallback] = useState(null)
  const [uploadFilesModal, setUploadFilesModal] = useState(false)
  const [uplaodFiles, setUplaodFiles] = useState([])
  const [uplaodModalMinimize, setUplaodModalMinimize] = useState(false)
  const [accountObj, setAccountObj] = useState({})
  const [contentModalProps, setContentModalProps] = useState({})
  const [contentModalNewProps, setContentModalNewProps] = useState({})
  const [artistModalProps, setArtistModalProps] = useState({})
  const [venueModalProps, setVenueModalProps] = useState({})
  const [pageModalProps, setPageModalProps] = useState({})
  const [iptvModalProps, setIptvModalProps] = useState({})
  const [iptvScheduleModalProps, setIptvScheduleModalProps] = useState({})
  const [isBrowser, setIsBrowser] = useState(true)
  const handleResize = () => {
    if (window.innerWidth > LG_SIZE) {
      setIsBrowser(true)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth > SM_SIZE) {
      setIsBrowser(false)
    } else {
      setIsBrowser(false)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  // useEffect(() => {
  //   const sessionId = localStorage.getItem('sessionId')
  //   if (sessionId) {
  //     validateSessionCall()
  //   }
  // }, [])
  //
  // const [
  //   { data: validateSession, loading: validateSessionLoading, error: validateSessionError },
  //   validateSessionCall,
  // ] = useAxios(
  //   {
  //     url: VALIDATE_SESSION,
  //     method: 'get',
  //   },
  //   { manual: true },
  // )
  //
  // const [{ data: logout, loading: logoutLoading }, logoutCall] = useAxios(
  //   {
  //     url: LOGOUT_API,
  //     method: 'get',
  //   },
  //   { manual: true },
  // )
  //
  // useEffect(() => {
  //   if (logout && logout.success) {
  //     setUserObj({})
  //     setIsLogin(false)
  //     localStorage.clear()
  //   }
  // }, [logout])
  //
  // useEffect(() => {
  //   setLoader(validateSessionLoading || logoutLoading)
  // }, [validateSessionLoading, logoutLoading])
  //
  // useEffect(() => {
  //   if (validateSession && validateSession.success) {
  //     setUser(validateSession.data)
  //   }
  // }, [validateSession])
  //
  // useEffect(() => {
  //   if (validateSessionError) {
  //     localStorage.clear()
  //   }
  // }, [validateSessionError])
  //
  // function setUser(data) {
  //   setUserObj(data.user)
  //   setIsLogin(true)
  //   localStorage.setItem('sessionId', data.user_session.session_id)
  // }
  return (
    <AppContext.Provider
      value={{
        setLoader,
        loader,
        accountObj,
        setAccountObj,
        uploadFinishCallback,
        setUploadFinishCallback,
        uplaodFilesModal: uploadFilesModal,
        setUplaodFilesModal: setUploadFilesModal,
        uplaodFiles,
        setUplaodFiles,
        uplaodModalMinimize,
        setUplaodModalMinimize,
        contentModalProps,
        setContentModalProps,
        artistModalProps,
        setArtistModalProps,
        venueModalProps,
        setVenueModalProps,
        pageModalProps,
        setPageModalProps,
        iptvModalProps,
        setIptvModalProps,
        iptvScheduleModalProps,
        setIptvScheduleModalProps,
        contentModalNewProps,
        setContentModalNewProps,
        isBrowser,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
